// GIAO DIỆN TỔNG 2026-10 — đánh dấu LƯỚI HAI CỘT bằng lớp / thuộc tính thay cho :has() trong style.css (07/10/2026).
//
// Vì sao: bản đầu của lưới dùng #main:has(> .card), #main > div:not([class]):has(> .card), .cmp-board:has(> .card),
// .kb-trang > :has(~ .kb-chay-vung). Đo bằng CDP Performance trên trang Bot (E2E boss-web W36, 1000 bot phát qua WS): MỖI nhóm :has() đó
// một mình đã làm thời gian tính lại kiểu (RecalcStyle) tăng từ ~2,1 s lên ~13–14 s — mỗi lần chèn một thẻ .card (thẻ bot cũng là .card)
// trình duyệt phải tính lại kiểu cả danh sách → trang Bot không kịp vẽ 1000 bot (W36 đỏ: 685–900/1004 thẻ sau 30 s).
// Cách sửa: một bộ theo dõi NHẸ (chỉ xét bản ghi có đích là #main / hộp bọc / vùng lưới — không quét lại cả trang) gắn:
//   · lớp "luoi-2"        lên #main, .cmp-board, [data-testid="bd-vung-thao-tac"] khi có thẻ (.card) là con trực tiếp (hoặc #main có hộp bọc chứa thẻ);
//   · data-luoi-boc="1"   lên hộp bọc KHÔNG lớp (div) là con của #main / .kb-trang và chứa trực tiếp .card (hoặc .kb-tan-suat trong .kb-trang).
// style.css dùng các dấu này thay cho :has() — bố cục y như cũ.

const VUNG = '.cmp-board, [data-testid="bd-vung-thao-tac"]';

const laThe = (e: Element): boolean => e.classList.contains("card");
/** div KHÔNG có thuộc tính class, chứa trực tiếp thẻ (.card) — hoặc (trong .kb-trang) khối tần suất .kb-tan-suat. */
export function laHopBoc(e: Element, trongKbTrang = false): boolean {
  if (e.tagName !== "DIV" || e.hasAttribute("class")) return false;
  for (const c of e.children) if (laThe(c) || (trongKbTrang && c.classList.contains("kb-tan-suat"))) return true;
  return false;
}
/** #main dùng lưới khi có thẻ là con trực tiếp, hoặc có hộp bọc không lớp chứa thẻ. */
export function mainCoLuoi(main: Element): boolean {
  for (const c of main.children) if (laThe(c) || laHopBoc(c)) return true;
  return false;
}
/** .cmp-board / vùng thao tác bản đồ dùng lưới khi có thẻ là con trực tiếp. */
export function vungCoLuoi(v: Element): boolean {
  for (const c of v.children) if (laThe(c)) return true;
  return false;
}

function datDau(el: Element, co: boolean, kieu: "lop" | "boc"): void {
  if (kieu === "lop") { if (el.classList.contains("luoi-2") !== co) el.classList.toggle("luoi-2", co); return; }
  const dang = (el as HTMLElement).dataset.luoiBoc === "1";
  if (dang === co) return;
  if (co) (el as HTMLElement).dataset.luoiBoc = "1"; else delete (el as HTMLElement).dataset.luoiBoc;
}

/** Đánh dấu lại các con trực tiếp của một cha (#main hoặc .kb-trang) là hộp bọc hay không. */
function danhDauCon(cha: Element, trongKbTrang: boolean): void {
  for (const c of cha.children) if (c.tagName === "DIV") datDau(c, laHopBoc(c, trongKbTrang), "boc");
}

/** Đánh dấu một vùng (#main / .kb-trang / .cmp-board / vùng bản đồ). Gọi lại nhiều lần không sao. */
export function danhDauVung(el: Element, main: Element | null): void {
  if (el === main) { datDau(el, mainCoLuoi(el), "lop"); danhDauCon(el, false); return; }
  if (el.classList.contains("kb-trang")) { danhDauCon(el, true); return; }
  if (el.matches(VUNG)) datDau(el, vungCoLuoi(el), "lop");
}

/** Đánh dấu toàn bộ một gốc (lúc khởi động / test). */
export function danhDauLuoi(main: Element): void {
  danhDauVung(main, main);
  for (const v of main.querySelectorAll(`.kb-trang, ${VUNG}`)) danhDauVung(v, main);
}

let daBat = false;
/** Bật một lần lúc khởi động (app.ts) trên #main. */
export function batLuoiTrang(main: HTMLElement | null = document.getElementById("main")): void {
  if (daBat || !main) return;
  daBat = true;
  const can = new Set<Element>();
  const xet = (el: Element | null): void => {
    if (!el) return;
    if (el === main || el.classList.contains("kb-trang") || el.matches(VUNG)) can.add(el);
  };
  new MutationObserver((ds) => {
    for (const r of ds) {
      const t = r.target as Element;
      xet(t); // thêm / bớt con trực tiếp của vùng
      if (t.tagName === "DIV" && !t.hasAttribute("class")) xet(t.parentElement); // thêm / bớt thẻ trong hộp bọc → cha xét lại
      for (const n of r.addedNodes) {
        if (!(n instanceof Element)) continue;
        xet(n);
        if (n.firstElementChild) for (const v of n.querySelectorAll(`.kb-trang, ${VUNG}`)) can.add(v); // vùng mới vẽ (cả trang)
      }
    }
    for (const el of can) if (el.isConnected) danhDauVung(el, main);
    can.clear();
  }).observe(main, { childList: true, subtree: true });
  danhDauLuoi(main);
}
